import { render, staticRenderFns } from "./DefaultStoreLinkForm.vue?vue&type=template&id=5bf23d0f"
import script from "./DefaultStoreLinkForm.vue?vue&type=script&lang=js"
export * from "./DefaultStoreLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports